declare global {
  interface Window {
    zE: any
    zESettings: any
  }
}

export function loadZendeskWidget(): void {
  if (document.getElementById('ze-snippet')) {
    initializeZendeskWidget()
    return
  }

  const script = document.createElement('script')
  script.id = 'ze-snippet'
  script.src = import.meta.env.VITE_APP_ZENDESK_CHAT_URL
  script.async = true

  script.onload = () => initializeZendeskWidget()

  document.head.appendChild(script)
}

export function initializeZendeskWidget(): void {
  const checkInterval = setInterval(() => {
    if (zendeskReady()) {
      clearInterval(checkInterval)
      safeZE('messenger', 'show')
    }
  }, 50)

  // optional: timeout after 10 seconds
  setTimeout(() => clearInterval(checkInterval), 10000)
}

export function zendeskReady(): boolean {
  return typeof window.zE === 'function'
}

export function hideZendeskWidget(): void {
  safeZE('messenger', 'close')
  safeZE('messenger', 'hide')
}

export function destroyZendeskWidget(): void {
  hideZendeskWidget()

  const snippet = document.getElementById('ze-snippet')
  if (snippet) snippet.remove()

  // Zendesk injects iframes and divs; remove them
  document.querySelectorAll('[id^="launcher"]').forEach((el) => el.remove())
  document
    .querySelectorAll('iframe[title*="Zendesk"]')
    .forEach((el) => el.remove())

  // Clean up globals so the SDK can't partially re-render
  delete window.zE
  delete window.zESettings
  Object.keys(window)
    .filter((key) => key.startsWith('__zendesk'))
    .forEach((key) => {
      delete (window as Record<string, unknown>)[key]
    })
}

export function safeZE(action: string, ...args: unknown[]) {
  if (zendeskReady()) {
    window.zE(action, ...args)
  } else {
    console.warn('[Zendesk] zE not ready:', action)
  }
}
